import Overnatting from "./Overnatting";

export default Overnatting;
